import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import API from './api';
import BaseLayout from './BaseLayout';
import AdminHome from './AdminHome';
import ManageTeachers from './ManageTeachers';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import ManageStudents from './ManageStudents';
import ManageVisits from './ManageVisits';
import AdminVisits from './AdminVisits';
import AdminRouting from './AdminRouting';
import TeachersAvailability from './TeachersAvailability';
import AllStudentsInfo from './AllStudentsInfo';
import StudentProgressReport from './StudentProgressReport';
import TeachersWorkReport from './TeachersWorkReport';
import AdminDocuments from './AdminDocuments';
import SettingsTimezone from './SettingsTimezone';
//import StudentMonthlyGoals from './StudentMonthlyGoals';
import StudentAchievement from './StudentAchievement';
import TeacherTimeLog from './TeacherTimeLog';
import MyStudentsAvailability from './MyStudentsAvailability';
import SmartScheduler from './SmartScheduler';
import TeacherDayPlanner from './TeacherDayPlanner';
//import UnifiedDayPlanner from './UnifiedDayPlanner';
import PricingAndCalculatorWithROI from './PricingAndCalculatorWithROI';
import Messages from './Messages';
import AboutHelp from './AboutHelp';
import Faq from './Faq';



const DashboardAdmin = () => {
  const location = useLocation();

  return (
    <BaseLayout role="admin">
      <Routes location={location}>
        <Route path="/" element={<AdminHome />} />
        <Route path="manage-teachers" element={<ManageTeachers />} />
	    <Route path="manage-students" element={<ManageStudents />} />
	    <Route path="visits" element={<AdminVisits />} />
	    <Route path="manage-visits" element={<ManageVisits />} />
	    <Route path="scheduler" element={<SmartScheduler />} />
	    <Route path="planer" element={<TeacherDayPlanner />} />


	    <Route path="students" element={<AllStudentsInfo />} />
	    <Route path="availability" element={<TeachersAvailability />} />
	  
	    <Route path="student-progress" element={<StudentProgressReport />} />
	    <Route path="work-report" element={<TeachersWorkReport />} />
	    <Route path="docs" element={<AdminDocuments />} />
	    <Route path="settings" element={<SettingsTimezone />} />

	    <Route path="achievement" element={<StudentAchievement mode="admin" />} />
	    <Route path="students-availability" element={<MyStudentsAvailability mode="admin" />} />
	    <Route path="teacher-timelogs" element={<TeacherTimeLog />} />
	    <Route path="messages" element={<Messages mode="admin"  />} />
	    <Route path="pricing" element={<PricingAndCalculatorWithROI />} />
	  
	    <Route path="about" element={<AboutHelp mode="admin"  />} />
	    <Route path="faq" element={<Faq mode="admin"  />} />
	  
        {/* dodaj druge rute */}
		<Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </BaseLayout>
  );
};

export default DashboardAdmin;

